// ---------------------------------------------------------------------------
// BYOD dashboard constants
// ---------------------------------------------------------------------------

/** Maximum non-section widgets allowed per dashboard. */
export const MAX_WIDGETS = 20;

/** Maximum tiles per row, keyed by row type. */
export const MAX_TILES_PER_ROW: Record<string, number> = {kpi: 4, viz: 2};

/** Number of placements per batch in the initial query. */
export const QUERY_BATCH_SIZE = 5;

/** Default number of rows shown per table page. */
export const DEFAULT_PAGE_SIZE = 10;

/** Filter types excluded from widget filter sidebars (handled by date range picker). */
export const DATE_FILTER_TYPES = new Set([
  'date_range_start',
  'date_range_end',
]);
